<template>
    <div class="multi-select-filter">
        <div :class="`dropdown ${isCalendar ? 'calendar-dropdown' : ''}`" ref="dropdown">
            <div class="token-input form-control d-flex align-items-center" v-if="isCalendar" data-bs-toggle="dropdown">
                <div class="chips d-flex flex-wrap align-items-center">
                    <div class="chip" v-for="user of getSelectedEmployees" :key="`${user.name}-${user.value}`">
                        <span class="d-flex align-items-center cursor-pointer" @click="(e) => removeUser(e, user)"
                            >x</span
                        >
                        <span class="label-content selected-user-name">
                            {{ user.name }}
                        </span>
                    </div>
                    <span class="chip selected-user-name" v-if="selectedItems.length > 3"
                        >+{{ selectedItems.length - 3 }} more</span
                    >
                    <input
                        type="text"
                        class="search-input"
                        :placeholder="placeholder"
                        v-model="calendarSearch"
                        :focus="open"
                    />
                </div>
                <div class="input-group-text"><i class="fas fa-search"></i></div>
            </div>

            <button
                v-else
                :class="`btn border bg-white dropdown-toggle px-2 ${disabled ? 'disabled' : ''} ${classes} `"
                type="button"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                :disabled="disabled"
            >
                <span class="message-container"> {{ message }} </span>
            </button>
            <div class="dropdown-menu p-0" ref="dropdownElement" v-show="!disabled">
                <form v-if="!isCalendar" @submit.prevent>
                    <div class="input-group p-1">
                        <input
                            type="text"
                            class="form-control"
                            :placeholder="getInputPlaceholder"
                            v-model="search"
                            v-on:keyup="onCredentialsFetch"
                            :focus="open"
                        />
                        <div class="input-group-append">
                            <div class="input-group-text">
                                <i class="fas fa-search"></i>
                            </div>
                        </div>
                    </div>
                </form>
                <ScrollPagination :page-number="pageNumber" v-on:pageNumberUpdate="pageNumberUpdated" v-if="isCalendar">
                    <section
                        class="content content-y h-100 d-flex flex-column overflow-auto flex-nowrap w-100 h-100 scroll-paginate"
                        :class="`${userOs == 'Windows' ? 'custom-scrollbar' : ''}`"
                    >
                        <template v-if="getIsSearching">
                            <span
                                class="dropdown-item ps-3"
                                v-for="(item, index) in uniqueFetchedItems"
                                :key="item.value"
                            >
                                <div class="form-check ps-0">
                                    <input
                                        type="checkbox"
                                        class="me-2"
                                        :id="`${name}fetched${item.value}${index}`"
                                        :value="item"
                                        v-model="selectedOptions"
                                        @change.prevent="updateSelectedItems"
                                    />
                                    <label class="form-check-label" :for="`${name}fetched${item.value}${index}`">
                                        <span class="label-content" :title="`${item.name.split('+')[0]}`" v-if="isMap"
                                            >{{ item.name.split("+")[0] }} <ProductPill :productId="item.application" />
                                        </span>
                                        <span class="label-content" :title="`${item.name}`" v-else>{{
                                            item.name
                                        }}</span>
                                    </label>
                                </div>
                            </span>
                            <div class="text-muted ps-3 pt-1" v-if="!fetchedItems || fetchedItems.length == 0">
                                No matches found
                            </div>
                        </template>
                        <template v-if="!getIsSearching">
                            <a class="clear-link pt-2 ps-2" @click="toggleSelection()"> Clear selected items </a>
                            <template v-if="selectedItems">
                                <span
                                    class="dropdown-item ps-3"
                                    v-for="(item, index) in displayItems"
                                    :key="item.value"
                                >
                                    <div class="form-check ps-0">
                                        <input
                                            type="checkbox"
                                            class="me-2"
                                            :id="`${name}display${item.value}${index}`"
                                            :value="item"
                                            v-model="selectedOptions"
                                            @change.prevent="updateSelectedItems"
                                        />
                                        <label class="form-check-label" :for="`${name}display${item.value}${index}`">
                                            <span
                                                class="label-content"
                                                :title="`${item.name.split('+')[0]}`"
                                                v-if="isMap"
                                                >{{ item.name.split("+")[0] }}
                                                <ProductPill :productId="item.application" />
                                            </span>
                                            <span class="label-content" :title="`${item.name}`" v-else>{{
                                                item.name
                                            }}</span>
                                        </label>
                                    </div>
                                </span>
                            </template>

                            <div class="text-muted ps-3 pt-1" v-if="!displayItems || displayItems.length == 0">
                                Nothing selected
                            </div>

                            <template v-if="suggestedItems && suggestedItems.length > 0">
                                <div class="dropdown-divider"></div>
                                <h6 class="ps-2 text-capitalize" v-if="name">
                                    <strong>{{ name }}</strong>
                                </h6>
                                <span
                                    class="dropdown-item p-0"
                                    v-for="(item, index) in uniqueSuggestedItems"
                                    :key="item.value"
                                >
                                    <div class="form-check pe-0">
                                        <input
                                            type="checkbox"
                                            class="me-2"
                                            :id="`${name}suggested${item.value}${index}`"
                                            :value="item"
                                            v-model="selectedOptions"
                                            @change.prevent="updateSelectedItems"
                                        />
                                        <label class="form-check-label" :for="`${name}suggested${item.value}${index}`">
                                            <span
                                                class="label-content"
                                                :title="`${item.name.split('+')[0]}`"
                                                v-if="isMap"
                                                >{{ item.name.split("+")[0] }}
                                                <ProductPill :productId="item.application" />
                                            </span>
                                            <span class="label-content" :title="`${item.name}`" v-else>{{
                                                item.name
                                            }}</span>
                                        </label>
                                    </div>
                                </span>
                            </template>
                        </template>
                    </section>
                </ScrollPagination>
                <div class="content content-y h-100" v-else>
                    <template v-if="getIsSearching">
                        <span class="dropdown-item ps-3" v-for="(item, index) in uniqueFetchedItems" :key="item.value">
                            <div class="form-check ps-0">
                                <input
                                    type="checkbox"
                                    class="me-2"
                                    :id="`${name}fetched${item.value}${index}`"
                                    :value="item"
                                    v-model="selectedOptions"
                                    @change.prevent="updateSelectedItems"
                                />
                                <label class="form-check-label" :for="`${name}fetched${item.value}${index}`">
                                    <span class="label-content" :title="`${item.name}`">{{ item.name }} </span>
                                </label>
                            </div>
                        </span>
                        <div class="text-muted ps-3 pt-1" v-if="!fetchedItems || fetchedItems.length == 0">
                            No matches found
                        </div>
                    </template>
                    <template v-if="!getIsSearching">
                        <a class="clear-link pt-2 ps-2" @click="toggleSelection()"> Clear selected items </a>
                        <template v-if="selectedItems">
                            <span class="dropdown-item ps-3" v-for="(item, index) in displayItems" :key="item.value">
                                <div class="form-check ps-0">
                                    <input
                                        type="checkbox"
                                        class="me-2"
                                        :id="`${name}display${item.value}${index}`"
                                        :value="item"
                                        v-model="selectedOptions"
                                        @change.prevent="updateSelectedItems"
                                    />
                                    <label class="form-check-label" :for="`${name}display${item.value}${index}`">
                                        <span class="label-content" :title="`${item.name}`">{{ item.name }} </span>
                                    </label>
                                </div>
                            </span>
                        </template>

                        <div class="text-muted ps-3 pt-1" v-if="!displayItems || displayItems.length == 0">
                            Nothing selected
                        </div>

                        <template v-if="suggestedItems && suggestedItems.length > 0">
                            <div class="dropdown-divider"></div>
                            <h6 class="ps-2 text-capitalize" v-if="name">
                                <strong>{{ name }}</strong>
                            </h6>
                            <span
                                class="dropdown-item ps-3"
                                v-for="(item, index) in uniqueSuggestedItems"
                                :key="item.value"
                            >
                                <div class="form-check ps-0">
                                    <input
                                        type="checkbox"
                                        class="me-2"
                                        :id="`${name}suggested${item.value}${index}`"
                                        :value="item"
                                        v-model="selectedOptions"
                                        @change.prevent="updateSelectedItems"
                                    />
                                    <label class="form-check-label" :for="`${name}suggested${item.value}${index}`">
                                        <span class="label-content" :title="`${item.name}`">{{ item.name }} </span>
                                    </label>
                                </div>
                            </span>
                        </template>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<style src="./MultiSelectFilter.scss"></style>
<script lang="ts" src="./MultiSelectFilter.ts"></script>
